import {get, post} from '../index'
export default {
  // 获取预约分类
  getAppointmentClassifyList (querys) {
    return get('/appoint/admin/AdminCate/cateList', querys)
  },
  // 添加预约分类
  addAppointmentClassify (querys) {
    return post('/appoint/admin/AdminCate/cateAdd', querys)
  },
  // 编辑预约分类、回显
  editAppointmentClassify (querys) {
    return post('/appoint/admin/AdminCate/cateUpdate', querys)
  },
  // 删除分类
  delAppointmentClassify (querys) {
    return post('/appoint/admin/AdminCate/cateDel', querys)
  },
  // 获取预约服务列表
  getAppointmentServiceList (querys) {
    return post('/appoint/admin/AdminProject/proList', querys)
  },
  // 预约服务表单编辑、回显
  getAppointmentServiceFormInfo (querys) {
    return post('/appoint/admin/AdminProject/proUpdate', querys)
  },
  // 预约服务信息上下架
  updateAppointmentServiceInfo (querys) {
    return post('/appoint/admin/AdminProject/changeStatus', querys)
  },
  // 预约服务表单添加
  addAppointmentServiceFormInfo (querys) {
    return post('/appoint/admin/AdminProject/proAdd', querys)
  },
  // 获取表单页面的分类下拉菜单
  getAppointmentProSetting () {
    return get('/appoint/admin/AdminProject/proSetting')
  },
  // 预约设置编辑与回显
  editAppointmentAppConfig (querys) {
    return post('/appoint/admin/AdminProject/appConfig', querys)
  },
  // 服务信息更新状态
  updateAppointmentStatus (querys) {
    return post('/appoint/admin/AdminProject/prodelete', querys)
  },
  // 获取客人订单
  getAppointmentRecordList (querys) {
    return get('/appoint/admin/AdminRecord/recordList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/appointment.js